/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Allows Machine List to be sortable

const sortableMenu = document.querySelector('.sortable-menu');
var sortable = new Draggable.Sortable(document.querySelectorAll('.sortable'), {
  	draggable: '.sort',
  	handle: '.draggable-icon',
	delay: 0,
 	mirror: {
		xAxis: false,
		appendTo: 'body',
        constrainDimensions: true
    },	
    swapAnimation: {
      duration: 300,	  	
      easingFunction: 'ease-in-out',
      horizontal: false,
    },
    plugins: [Draggable.Plugins.SwapAnimation],
});

sortable.on('sortable:stop', (e) => {
	
	function moveElement(array, fromIndex, toIndex) {
	  const element = array.splice(fromIndex, 1)[0]; // Remove the element
	  array.splice(toIndex, 0, element); // Insert it at the new position
	  return array;
	}

	moveElement(machineArray, e.newIndex, e.oldIndex);	
	
	setTimeout(function () {
		// reset id number
		$('.machineListItem').each(function(index) {
		  $(this).attr('id', (machinesLength - index - 1 || 0));			
		});		
		
	}, 0);
	
	setTimeout(function () {		
		setToStorage();
	}, 200);
});

// Start Serial Number Process
var machineArray =[];
var currentSKU = $('#epProductSKU').text();
const machineList = $('#activeMachines');
var machinesLength = $('.machineListItem').length || 0;

// Collection or Search	
var pageType = window.theme.pageType;
var activateSearch = false;

var assetPath = 'https://cdn.shopify.com/s/files/1/0363/9266/5221/t/59/assets/';
var plusIcon = "<svg class='icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' style='width:20px; height: 20px;'><path d='M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z'/></svg>"

// Messages
function enableCartButton(message){
	$('#buttonWarning .product-form__add-button').removeAttr('disabled');
  	$('.product-form__payment-container').removeClass('serialDisabled');  
  	$('.serialMessage').removeClass('inactiveSerial');
  	$('.serialWarning').html(message).fadeIn();	
}

function disableCartButton(message){
	$('#buttonWarning .product-form__add-button').attr("disabled", "disabled");
    $('.product-form__payment-container').addClass('serialDisabled');
	$('.serialMessage').addClass('inactiveSerial');    
    $('.serialWarning').html(message).fadeIn();
}

var duplicateWarning = '<span class="ep-error"><svg viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"/></svg>This machine has already been added, please try again</span>';
var serialWarning = '<span class="ep-error"><svg viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"/></svg>Please Insert a Valid Serial Number</span>';	
var machineMatchWarning = '<span class="ep-error"><svg viewBox="0 0 512 512"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"/></svg>WARNING: This part/accessory is not compatible <br>with the selected machine.</span>';
var machineValidationWarning = '<span class="ep-warning"><svg viewBox="0 0 512 512"><path d="M504 256c0 137-111 248-248 248S8 393 8 256C8 119.1 119 8 256 8s248 111.1 248 248zm-248 50c-25.4 0-46 20.6-46 46s20.6 46 46 46 46-20.6 46-46-20.6-46-46-46zm-43.7-165.3l7.4 136c.3 6.4 5.6 11.3 12 11.3h48.5c6.4 0 11.6-5 12-11.3l7.4-136c.4-6.9-5.1-12.7-12-12.7h-63.4c-6.9 0-12.4 5.8-12 12.7z"/></svg> WARNING: There was an error with the validation. This part may not be compatible with the selected machine.</span>';	
var successWarning = '<span class="ep-success"><svg viewBox="0 0 512 512"><path d="M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM227.3 387.3l184-184c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0L216 308.1l-70.1-70.1c-6.2-6.2-16.4-6.2-22.6 0l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6l104 104c6.2 6.2 16.4 6.2 22.6 0z"/></svg>Success! This item is compatible <br>with the selected machine.</span>';

// Here is where the storage code starts
function setToStorage(){localStorage.setItem('EP-Machines', JSON.stringify(machineArray));}

function addMachine(data, index){
	//console.log(JSON.stringify(machineArray));
	
	var marketingName = data.marketingName;
	var marketingURL = marketingName.replace(/\s+/g, '-').toLowerCase();
	$('.machineListItem').removeClass('activeMachineListItem');

	var machineCodeBlock = 
		'<div id="'+index+'" class="machAnimate activeMachineListItem machineListItem"> \
			<div class="machineListHeader"> \
				<div><div class="active">Active</div> \
				<div class="activateThisMachine link">Activate</div></div> \
				<div class="removeThisMachine link">Remove</div> \
			</div> \
			<div class="mini-cart__line-item"> \
				<div class="mini-cart__image-wrapper"> \
					<img src="'+ assetPath + marketingURL + '_icon.jpg" alt="' + marketingName + '"> \
				</div> \
				<div class="mini-cart__item-wrapper"> \
					<div class="mini-cart__product-info"> \
						<h3 class="heading text--strong ep-margin-remove-bottom">' + marketingName + '</h3> \
						<span class="machineListWattage">' + data.wattage + '</span> \
						<div><span class="machineListSerial"><span class="heading">Serial: </span>' + data.serialNumber + '</span></div> \
					</div> \
				</div> \
				<div class="draggable-icon"></div> \
			</div> \
		</div>';

	machineList.prepend(machineCodeBlock);
	if (machinesLength > 1){machineList.children('.machineListItem:not(.activeMachineListItem)').addClass('sort');}
	machinesLength++;
	
	//set new icon image
	$('.machine-img').css("background-image", "url(" + assetPath + marketingURL + "_icon.jpg)");
	$('#validation-icon .machine-img').addClass('icon-bounce');
	$('.machine-name').html(marketingName);
	$('.machine-serial').html(data.serialNumber);
	
	$('.MachineDesc').addClass('textReveal');	
	
	setTimeout(function () {
		$('.machAnimate').addClass('machineReveal');
        $('.machineSerialInput label').html('Want to use a Different Serial Number?').fadeIn(500);        
		$('#validation-icon .machine-img').removeClass('icon-bounce');
	}, 0);
}

//Active Machine redirects
var urlFilter = '';

if (pageType === 'search') {urlFilter = '&' + window.location.href.split('?')[1];}

/*if ($('.partSearch').length > 0){urlFilter = '&filter.p.product_type=Part';}
else if($('.accessorySearch').length > 0){urlFilter = '&filter.p.product_type=Accessories';}*/

//ORG else if (pageType === 'collection') {urlSnippet = '/collections/' + window.location.pathname.split('/')[2] + '?sort_by=title-ascending';}
// this is new format for search: /8000-MINI-MT-24x12-45W-CO2?sort_by=title-ascending&filter.p.product_type=Part&q=belt

	
function activeMachineSearch(index){	
	// Get service list and appy to url
	var serviceListTag = machineArray[index].serviceListName.replace(/[^\w\s]|_/g, "").replace(/\s+/g, '-');
	location.href = '/collections/' + serviceListTag + '?sort_by=title-ascending' + urlFilter;	
}

function checkCompatibility(index){		
	if (pageType === 'product') {
		if ($.inArray(currentSKU, machineArray[index].items) !== -1){						
			enableCartButton(successWarning);
            //this adds the serial number to the mini cart when added to cart
            $('#active-serial-number-input').val(machineArray[index].serialNumber);
		}else {
			disableCartButton(machineMatchWarning);
            $('#active-serial-number-input').val('');
		}	
	} else{}
}

function activateMachine(){
	$('#machinePanel').on('click', '.activateThisMachine', function(){		
		var thisMachine = $(this).closest('.machineListItem');
		var newID = thisMachine.attr('id');
		var activeMarketingName = machineArray[newID].marketingName;
		var newURL = activeMarketingName.replace(/\s+/g, '-').toLowerCase();
        checkCompatibility(newID);
		if($('.machineListItem').length > 1){ $('.activeMachineListItem').addClass('sort');}
		$('.activeMachineListItem').removeClass('activeMachineListItem');
		thisMachine.addClass('activeMachineListItem').removeClass('sort');
		$('#activeMachines').prepend(thisMachine);		
		$('.machine-img').css("background-image", "url(" + assetPath + newURL + "_icon.jpg)");
		$('.machine-name').html(activeMarketingName);
		$('.machine-serial').html(machineArray[newID].serialNumber);		
		machineArray.push(machineArray.splice(newID,1)[0]);		
		// reset id number
		$('.machineListItem').each(function(index) {
		  $(this).attr('id', (machinesLength - index - 1 || 0));			
		});		                
				
		setTimeout(function () {						
			setToStorage();            
		}, 0);
	});
}

function removeMachines(){
	
	// Remove all machines from list and local storage
	localStorage.clear();		
	machineArray = [];
	
	$(".serialWarning").fadeOut();
	$('#validation-icon .machine-img').css("background-image", "url('https://cdn.shopify.com/s/files/1/0363/9266/5221/t/59/assets/default-machine_icon.jpg')");
	$('.MachineDesc').removeClass('textReveal');	
	$('.machAnimate').removeClass('machineReveal');
    $('.machineSerialInput label').html('Laser Machine Serial Number<span class="ep-red">*</span>: (Required)').fadeIn(500);    
	
	$('.product-form__payment-container').addClass('serialDisabled');
	machinesLength = 0;	
	
	setTimeout(function () {		
		machineList.empty();
		$('.machine-name').html(plusIcon);
		$('.machine-serial').html('');
	}, 400);
	
}

function removeMachine(){
	$('#machinePanel').on('click', '.removeThisMachine', function(){
		if($('.machineListItem').length > 1){			
			var thisMachine = $(this).closest('.machineListItem');
			var thisID = thisMachine.attr('id');
			machinesLength--;
			//set new active if needed
			if(thisMachine.hasClass('activeMachineListItem')){			
				var newItem = $('.machineListItem').next()
				var nextID = newItem.attr('id');
				var activeMarketingName = machineArray[nextID].marketingName;
				var newURL = activeMarketingName.replace(/\s+/g, '-').toLowerCase();
                checkCompatibility(nextID);
				$('#'+nextID).addClass('activeMachineListItem');
				$('.machine-img').css("background-image", "url(" + assetPath + newURL + "_icon.jpg)");
				$('.machine-name').html(activeMarketingName);
				$('.machine-serial').html(machineArray[nextID].serialNumber);								
			}
			
			if($('.machineListItem').length < 4){$('.machineListItem').removeClass('sort');}
			
			thisMachine.removeClass('machineReveal');
			machineArray.splice(thisID, 1);			
			
			setTimeout(function () {						
				setToStorage();
			}, 0);
			
			setTimeout(function () {		
				thisMachine.remove();
				// reset id number
				$('.machineListItem').each(function(index) {
				  $(this).attr('id', (machinesLength - index - 1 || 0));			
				});
			}, 400);		
			
			
		}else{			
			removeMachines();			
		}		
	});
}

function checkStorage(){
	//(localStorage.getItem("EP-Machines") === null){
	if ('EP-Machines' in localStorage) {	
		// get local storage, sanitize and push to array
		machineArray = JSON.parse(localStorage.getItem('EP-Machines'));
		// for each item in array, add to dropdown
		machineArray.forEach(addMachine);		
		
		setTimeout(function(){
			var adjMachinesLength = machinesLength - 1 || 0;
			checkCompatibility(adjMachinesLength);			
		},0);
		
	}	
	else{
		// No machines
	}
};

// Popups
function toggleWarrantyPopup(){$("#machineSelectorWrapper.ep-popup").fadeOut();$("#warrantyPopupWrapper.ep-popup").fadeIn();}

$("#machineSelectorWrapper.ep-popup, #machineSelectorWrapper .closePopup").on("click", function () {$(".ep-popup").fadeOut();});

$("#warrantyPopupWrapper.ep-popup, #warrantyPopupWrapper .closePopup").on("click", function () {
	$("#warrantyPopupWrapper.ep-popup").fadeOut();
	
	if (activateSearch == true){
		var adjMachinesLength = machinesLength - 1 || 0;
		activeMachineSearch(adjMachinesLength);
	}
	
});

$("#warrantyPopup, #machineSelector").on("click", function (event) {event.stopPropagation();});

// Serial Validation
function validateSerial(){
	$('.serial-input').on('click', function () {
		$(".serialWarning").fadeOut();
	});			
	$('.serial-button').on("click", async function(){
		var serialNumber = $(this).closest('.serial-wrapper').find('.serial-input').val();
		var len = serialNumber.length;		
		
		//first validation based on length  
		if(len > 11 && len < 21) {
			// Check for duplicate entry
			function checkForDuplicates(array, key, value) {
				for (var i = 0; i < array.length; i++) {
					if (array[i][key] === value) {
						return array[i];
					}
				}
			}
			// second validation based on existing duplicate
			var result = checkForDuplicates(machineArray, 'serialNumber', serialNumber);
			if (result) {
				disableCartButton(duplicateWarning);
			} else {
	
				try {
					$('#ep-spinner').fadeIn();
					const response = await fetch("https://epilogportalapiprod-arb4epdfcrcafwh0.eastus-01.azurewebsites.net/api/EpilogPortalAPI/GetSerialDetails/" + serialNumber + "/bxiFmd3r9SQQGNQGHjyP",{
					  headers: {
						'Content-Type': 'text/plain' 
					  },
					  method: "GET"});
					// Answer returned
					if (response.ok) {
						const data = await response.json();
						$('#ep-spinner').fadeOut();
						// currently needs message in dropdown or filter
						if (data.errorMessage == 'Invalid Serial Number.'){
							disableCartButton(serialWarning);
						}
						// currently needs message in dropdown or filter
						else if(data.errorMessage == 'Unable to verify serial number.'){
							enableCartButton(machineValidationWarning);
						}
						else{		
							// Successful Serial Number
							$('.serial-input').val("");
							//add machine to array
							machineArray.push(data);
							//add machine to dropdown
							addMachine(data, machinesLength);
							//add machine to local storage
							setToStorage();							
							// Check Warranty
							var filterRedirect = false;
							if ($(this).hasClass('filter-serial-button')){filterRedirect = true;}
							
							if ((data.inWarranty == true) && (filterRedirect == false)){								
								toggleWarrantyPopup();
							} else if ((data.inWarranty == true) && (filterRedirect == true)){								
								toggleWarrantyPopup();								

								//add event listner when executed do next thing								
								$("#warrantyPopupWrapper.ep-popup, #warrantyPopupWrapper .closePopup").on("click", function () {
									$("#warrantyPopupWrapper.ep-popup").fadeOut();

										var adjMachinesLength = machinesLength - 1 || 0;											activeMachineSearch(adjMachinesLength);										

								});
									
							} else if (filterRedirect == true){
								var adjMachinesLength = machinesLength - 1 || 0;
								activeMachineSearch(adjMachinesLength);
							}
							
							// Check page for filter or compatibility							
							setTimeout(function(){
								var adjMachinesLength = machinesLength - 1 || 0;
								checkCompatibility(adjMachinesLength);			
							},0);
						}
					} else {
						//console.error("Error fetching data:", response.status, response.statusText);
						$('#ep-spinner').fadeOut();			
						enableCartButton(machineValidationWarning);
					}
				} catch (error) {
					//console.error("Error:", error.message);
					disableCartButton(serialWarning);
				}
			}
		}
		else{
			disableCartButton(serialWarning);		
		}		
	});
}

function coolCheckBox(){
  $('.accessories-title').removeAttr('href');
  $('.accessories-left input').wrap("<div class='ep-checkBoxes path'></div>").after('<svg viewBox="0 0 21 21" class="epCheckBox"><path d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186"></path></svg><svg class="epAddIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width:20px; height: 20px;"><path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"></path></svg>');
}

// Set global variables for price variations
var ep_accessory_total = 0;

var org_price = parseFloat($('#ep-org-price').text().toString().replace(/[^0-9.]/g, ""));

function setPackagePrice(){
	
	var new_price;
	var quantity_total = $('.quantity-selector input').val();
	
	//get swatch price  
	var variant_string = $('.product-form__variants .select-wrapper option:selected').text();
	var variant_price = parseFloat(variant_string.substr(variant_string.lastIndexOf("-") + 2).toString().replace(/[^0-9.]/g, ""));
		
	if (variant_price >= 0){
		//alert(Number(ep_accessory_total));
		new_price = ((variant_price * quantity_total) + Number(ep_accessory_total)).toFixed(2);
	}
	else{
		new_price = ((org_price * quantity_total) +  Number(ep_accessory_total)).toFixed(2);
	}
	
	var string_commatized = new_price.replace(/\d(?=(\d{3})+\.)/g, '$&,')  
  	$('#ep-price').text( "$" + string_commatized );
		
}

function activateAccessory(){  //get accessory Total 

  $('.accessories-item, .accessories-item input[type=checkbox]').on('click', function() {

    var new_price;
    var checkbox;
	  
     // Get checkbox and prices
    if ($(this).is(':checkbox')) {var checkbox = $(this);}
    else{var checkbox = $(this).find('input[type=checkbox]');}     
      	 
    var accessory_price = parseFloat($($(this).find('.accessory-price')[0]).text().toString().replace(/[^0-9.]/g, ""));            
            
    // Update 'selected' state and calculate updated price	  
       	
    if ($(checkbox).is(':checked')){    	
     	$(this).removeClass('active').attr('title', 'Add to Selection');
     	$(checkbox).prop('checked', false);
        
        new_accessory_total = ( -1 * accessory_price + Number(ep_accessory_total)).toFixed(2);
		ep_accessory_total = new_accessory_total;
       
    } else {		
        $(checkbox).prop('checked', true);
        $(this).addClass('active').attr('title', 'Remove from Selection');       
                      
        new_accessory_total = (accessory_price + Number(ep_accessory_total)).toFixed(2);
		ep_accessory_total = new_accessory_total;
    }

	// Update price
    setPackagePrice();
                                                 
  });   
}

function updateTotalPrice(){  
  $('.block-swatch__item, .quantity-selector__button').click(function(){	  
    setTimeout(function() { 
		setPackagePrice();  	
		
		//Set Base Price
		var variant_string = $('.product-form__variants .select-wrapper option:selected').text();
		var variant_price = parseFloat(variant_string.substr(variant_string.lastIndexOf("-") + 2).toString().replace(/[^0-9.]/g, ""));
		var string_commatized = variant_price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');    	
  		$('#ep-org-price').text( "$" + string_commatized );
    });    
  }); 
}

function mandatoryAirPump(){
	var airPump = $('#accessory-5052108603525').closest('.accessories-item');	
	var APCheckbox = airPump.find('input[type=checkbox]');
	var pump_price = parseFloat($(airPump.find('.accessory-price')[0]).text().toString().replace(/[^0-9.]/g, ""));       

	airPump.addClass('active').attr('title', 'Remove from Selection');
	APCheckbox.prop('checked', true);
    $('#accessory-5052108603525').after('<p class="ep-text-small ep-margin-remove-bottom"><i>An air compressor is <span class="ep-red">REQUIRED</span> for safe laser operation. Remove if you are providing your own air compressor, 30 PSI max.</i></p>');
	
    var new_accessory_total = (pump_price + Number(ep_accessory_total)).toFixed(2);
	ep_accessory_total = new_accessory_total;
	
    // Update price
    setPackagePrice();
  	setTimeout(function(){
		enableCartButton(); 
	}, 300);	
}

function repairVariants(){
  setTimeout(function() {

    	$('.product-form__single-selector').on('change', function() {       
        if($(this).parent().hasClass('block-swatch--disabled')){
          
          setTimeout(function() {             
            $('#addToCartCopy').attr('disabled', 'disabled').addClass('button--disabled').removeClass('button--primary').removeAttr('data-action').text('Currently Out of Online Stock');
          });
        }
      else{		 
        setTimeout(function() {          
          $('#addToCartCopy').removeAttr('disabled').removeClass('button--disabled').addClass('button--primary').attr('data-action', 'add-to-cart').text('Add to Cart');
        });
      } 
    });
    
  });
}

function accessoriesDoneLoadingCallback() {    
    coolCheckBox();  	
  	repairVariants();
	activateAccessory();
    if($('#accessory-5052108603525').length > 0){
    	mandatoryAirPump();
    }else{
      setTimeout(function(){
		enableCartButton(); 
	}, 300);}		
}

/*function toggleFilter(){	
	if ($('#filter.p.product_type-Part').prop("checked", true)){alert('part checked'); $('.toggleParts').fadeIn();}
	else {alert('not checked');}
}*/

$(document).ready(function() {
		
	// Start Serial Process
	checkStorage();		  
	validateSerial();
	
	activateMachine();
	removeMachine();
	//toggleFilter();
	
	$('.removeMachines').on('click', function(){removeMachines();});

    $('.machineToggle').on('click', function(){$("#machineSelectorWrapper.ep-popup").fadeIn();});
	
	$('#ep-serial-filter').on('click', '.filter-active-serial-button', function(){
		activateSearch = true;
		var adjMachinesLength = machinesLength - 1 || 0;
		activeMachineSearch(adjMachinesLength);					
	});
	
	//initiate addon package
	if($('#ep-package-wrapper').length > 0){
		updateTotalPrice();
	}

    $('.ep-tabs-list-item').click(function(){
        var tab_id = $(this).attr('data-tab');
  
        $('.ep-active').removeClass('ep-active');
        $('.ep-tab-content').removeClass('ep-current');
  
        $(this).addClass('ep-active');
        $("#"+tab_id).addClass('ep-current');
     });   
  
});

// FINALLY console.log(machineArray[1].items);
	//console.log(machineArray[index].items);
	//console.log(machineArray[index].marketingName);
	//console.log(JSON.stringify(machineArray));

	//console.log(machineArray[1].items);
	//console.log(data);
	//console.log(data.marketingName);
